<template>
    <modal @closed="handleClosed" :cancel-button-text="$t('CONFIRM_MODAL_OKAY')" class="pause-modal" custom-class="max-w-lg">
        <h2 class="pause-modal--heading" v-text="$t('PAUSE_DELIVERIES_CONFIRMATION_MODAL_YOUR_DELIVERIES', { firstName })"></h2>
        <i v-if="loading" class="loader__loading-icon fa-spin"/>
        <div v-else>
            <p v-if="restartDate" v-html="restartDateString"></p>
            <p v-else-if="fromStep === 'lilyFree'" v-html="lilyFreeString"></p>
            <p v-else v-text="$t('PAUSE_DELIVERIES_CONFIRMATION_MODAL_RESTART_THEM')"></p>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/structure/Modal';
import { formatDisplayDate } from '@/helpers/DateHelpers';

export default {
    name: 'PauseDeliveriesConfirmationModal',
    components: {
        Modal,
    },
    props: {
        subscriptionId: {
            required: true,
            type: Number,
        },
        fromStep: {
            default: '',
            type: String,
        },
    },
    data() {
        return {
            loading: true,
        };
    },
    mounted() {
        this.$store.dispatch('subscription/fetchAllSubscriptions', true).then(() => {
            this.loading = false;
        });
    },
    computed: {
        ...mapGetters({
            firstName: 'account/getFirstName',
            isLilyFree: 'account/getIsLilyFree',
        }),
        subscription() {
            return this.$store.getters['subscription/getSubscriptionById'](this.subscriptionId);
        },
        restartDate() {
            return this.subscription.resume_date;
        },
        restartDateString() {
            const formattedDate = formatDisplayDate(new Date(this.restartDate), 'do MMMM yyyy');
            if (!this.restartDate) return;
            return this.fromStep === 'goingAway'
                ? this.$t('PAUSE_DELIVERIES_CONFIRMATION_MODAL_RESTART_DATE_GOING_AWAY', { restartDate: formattedDate })
                : this.$t('PAUSE_DELIVERIES_CONFIRMATION_MODAL_RESTART_DATE_RENOVATING_HOUSE', { restartDate: formattedDate });
        },
        lilyFreeString() {
            return this.isLilyFree && this.fromStep === 'lilyFree' && this.$t('PAUSE_DELIVERIES_CONFIRMATION_MODAL_LILY_FREE');
        },
    },
    methods: {
        handleClosed() {
            this.$emit('pause-deliveries-modal-closed');
        },
    },
};
</script>

<style lang="scss" scoped>
    .pause-modal {
        text-align: center;
    }
    .pause-modal--heading {
        font-size: 25px;
        line-height: 30px;
    }
</style>
